// extracted by mini-css-extract-plugin
export default {"root":"style_root__RGb9L","cards_container":"style_cards_container__OMF9N"};